import { FC } from 'react'
import s from './tabs.module.scss'
import { TabItem } from '@components/UIKit/Tabs/TabItem'
import { ITabItem } from '@specs/types'

interface Props {
    tabs: ITabItem[]
}

export const Tabs: FC<Props> = ({ tabs }) => (
    <div className={s.tabs}>
        {tabs.map(tab => (
            <TabItem
                key={tab.text}
                {...tab}
            />
        ))}
    </div>
)
